/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ code: NonNullable<unknown> }} Toast_Pos_Order_SavedInputs */

const vi_toast_pos_order_saved = /** @type {(inputs: Toast_Pos_Order_SavedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Đã lưu đơn ${i?.code}`)
};

/**

* @param {Toast_Pos_Order_SavedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const toast_pos_order_saved = /** @type {((inputs: Toast_Pos_Order_SavedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_Pos_Order_SavedInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_toast_pos_order_saved(inputs)
});